export default class FormActions {
    initialize() {
        this.submitClosestFormOnLinkClick();
    }

    submitClosestFormOnLinkClick() {
        $('.submit-closest-form').each(function () {
            const this_link = $(this);

            this_link.on('click', function (e) {
                e.preventDefault();

                this_link.closest('form').trigger('submit');
            });
        });
    }
}
